import reducer from "./reducer";

export { actionTypes as mobileScreenActionTypes, default as mobileScreenOperations } from "./actions";
export { default as mobileScreenSelectors } from "./selectors";

export default reducer;
